var _defs, _circle, _line, _line2, _line3, _line4, _line5, _line6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlpha(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.7 126.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#669;stroke-miterlimit:10;stroke-width:4.04px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 63.35,
    cy: 63.35,
    r: 61.33
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 64.02,
    y1: 125.35,
    x2: 64.02,
    y2: 1.35
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 74.8,
    y1: 124,
    x2: 74.8,
    y2: 4.04
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 85.59,
    y1: 119.96,
    x2: 85.59,
    y2: 6.07
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 96.37,
    y1: 113.89,
    x2: 96.37,
    y2: 12.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 107.15,
    y1: 106.48,
    x2: 107.15,
    y2: 19.54
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 117.93,
    y1: 90.98,
    x2: 117.93,
    y2: 35.72
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpha);
export default __webpack_public_path__ + "static/media/alpha.044f2edb0a2dd1dad9435f7d4b3f6d6c.svg";
export { ForwardRef as ReactComponent };